
function checkSelection() {
    return function (options, input) {
        if (!!input) {
            let results = [], txt = 'DESELECT ALL';
            if (angular.isObject(input)) {
                angular.forEach(options, function (opt) {
                    for (let key of Object.keys(input)) {
                        let value = opt[key];
                        if (!key.includes('$')) {
                            if (Array.isArray(value)) {
                                if (value.some(v => v && v.toString().toLowerCase().includes(input.toLowerCase()))) {
                                    results.push(opt);
                                    break;
                                }
                            }
                            else if (typeof value === 'string') {
                                if (value.toLowerCase().includes(input[key].toLowerCase())) {
                                    results.push(opt);
                                    break;
                                }
                            }
                        }
                    };
                });
                if (!!input['$field']) {
                    let cmpKey = input['$key'];
                    if (!!results.find(r => input['$field'].findIndex(s => s[cmpKey] == r[cmpKey]) == -1)) {
                        txt = 'SELECT ALL'
                    }
                    $('#ui-select-choices-' + input['$select']['generatedId']).find('.dropdown-header').text(txt);
                }
                return results;
            }
            else if (typeof input == "string") {
                let keys = Object.keys(options);
                angular.forEach(options, function (opt) {
                    for (let key of keys) {
                        let value = opt[key];
                        if (Array.isArray(value)) {
                            if (value.some(v => v && v.toString().toLowerCase().includes(input.toLowerCase()))) {
                                results.push(opt);
                                break;
                            }
                        } else if (typeof value === 'string') {
                            if (value.toLowerCase().includes(input[key].toLowerCase())) {
                                results.push(opt);
                                break;
                            }
                        }
                    }

                });
                return results;
            }
        }
        return options;
    }

}

angular.module('eCareVault.common.filters').filter('checkSelection', checkSelection);
